module.exports = __webpack_public_path__ + "static/media/left_arrow.ab031f2d.png";